import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d449a16")

_pushScopeId("data-v-7d449a16")
const _hoisted_1 = { class: "row justify-content-md-center" }
const _hoisted_2 = { class: "col-12 col-lg-5 col-xl-4" }
const _hoisted_3 = { class: "card shadow" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-5" }
const _hoisted_7 = {
  key: 0,
  class: "pair-item pair-item-value"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "pair-item" }
const _hoisted_10 = { class: "col-7 text-right" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "font-weight-bold text-secondary block" }, "|", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AdvanceTransaction = _resolveComponent("AdvanceTransaction")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.parity,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.parity = $event)),
                options: _ctx.pairs,
                optionLabel: "pairId",
                filter: true,
                placeholder: "Select a Pair",
                showClear: true
              }, {
                value: _withId((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("div", null, _toDisplayString(slotProps.value.pair?.baseCurrencyId) + "/" + _toDisplayString(slotProps.value.pair?.quoteCurrencyId), 1)
                      ]))
                    : (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(slotProps.placeholder), 1))
                ]),
                option: _withId((slotProps) => [
                  _createVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(slotProps.option.pair?.baseCurrencyId) + "/" + _toDisplayString(slotProps.option.pair?.quoteCurrencyId) + " ", 1),
                    _createVNode(_component_icons_currency, {
                      pairType: !_ctx.isFiat(slotProps.option.pair?.quoteCurrencyId) ? 'crypto' : null ,
                      localCurrency: slotProps.option.pair?.quoteCurrencyId,
                      cryptoCurrency: slotProps.option.pair?.baseCurrencyId,
                      width: '20',
                      height: '20',
                      color: true,
                      reverse: _ctx.type == 'BUY' ? false : true
                    }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("button", {
                disabled: !_ctx.parity?.pair?.allowBuy,
                class: ["btn font-weight-bold", _ctx.type == 'BUY' ? 'text-success' : 'text-secondary'],
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTrans('BUY'))),
                href: "#"
              }, "BUY", 10, ["disabled"]),
              _hoisted_11,
              _createVNode("button", {
                disabled: !_ctx.parity?.pair?.allowSell,
                class: ["btn font-weight-bold", _ctx.type == 'SELL' ? 'text-danger' : 'text-secondary'],
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchTrans('SELL'))),
                href: "#"
              }, "SELL", 10, ["disabled"])
            ])
          ]),
          (_ctx.parity)
            ? (_openBlock(), _createBlock(_component_AdvanceTransaction, {
                key: 0,
                type: _ctx.type,
                parity: _ctx.parity,
                tradeType: "market"
              }, null, 8, ["type", "parity"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})